<template>
  <!-- Row -->
  <div class="navigation-bar">
    <div class="tab-struct custom-tab-1">
      <ul class="nav nav-tabs">
        <component
          v-for="(tab, tabIndex) in tabs"
          :key="tabIndex"
          v-bind:is="'nav-tab'"
          :title="tab.name"
          :isSelected="selectedTab === tabIndex"
          @click="selectTab(tabIndex)"
        />
      </ul>
    </div>
  </div>
  <!-- Row -->
</template>

<script>
import NavTab from './NavTab';

export default {
  name: 'NavBar',
  components: {
    'nav-tab': NavTab,
  },
  props: {
    tabs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  created() {},
  computed: {},
  methods: {
    selectTab(selectedTabIndex) {
      this.selectedTab = selectedTabIndex;
      this.$emit('tabChanged', selectedTabIndex);
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.navigation-bar {
  font-size: 20px;
}

li {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/navigations/NavBar.vue